export * from './imageStyle';

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

export const ROUTES = {
  LOGIN: '/login',
  STORIES: '/stories',
  STORY_DETAIL: '/stories/:id',
  EPISODES: '/episodes',
  EPISODE_DETAIL: '/episodes/:id',
  TAGS: '/tags',
  USERS: '/users',
  SOURCE_STORIES: '/source-stories',
  SOURCE_STORY_DETAIL: '/source-stories/:id',
  FILM_WORKFLOW: '/source-stories/:storyId/film/:planId/workflow', // 261010 P2a: khung mới 9 bước (plan Sky; Sơ đồ / Storyboard / Prompt có thao tác)
  FILM_WORKFLOW_FOUR: '/source-stories/:storyId/film/:planId/workflow-four', // 261030 Phase A: khung 4 bước
  FILM_WORKFLOW_FOUR_CREATE: '/source-stories/:storyId/film/create-four', // 261030 Phase A: tạo plan layout-four
  PROMPT_TEMPLATES: '/prompt-templates',
  IMAGE_STYLES: '/image-styles',
  AUDIO_LIBRARY: '/audio-library',
} as const;

export const STORY_STATUS = {
  DRAFT: 'draft',
  PUBLISHED: 'published',
  ARCHIVED: 'archived',
} as const;

export const EPISODE_STATUS = {
  DRAFT: 'draft',
  UPLOADING: 'uploading',
  PROCESSING: 'processing',
  READY: 'ready',
  SCHEDULED: 'scheduled',
  PUBLISHED: 'published',
  ERROR: 'error',
  FAILED: 'failed',
} as const;

export const TAG_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
} as const;

export const GENDER = {
  MALE: 'male',
  FEMALE: 'female',
  UNISEX: 'unisex',
} as const;

export const VIDEO_JOB_STATUS = {
  PENDING: 'pending',
  PROCESSING: 'processing',
  COMPLETED: 'completed',
  FAILED: 'failed',
} as const;

export const USER_ROLES = {
  SUPER_ADMIN: 'superadmin',
  ADMIN: 'admin',
  EDITOR: 'editor',
} as const;

export const UPLOAD_STATUS = {
  UPLOADING: 'uploading',
  PROCESSING: 'processing',
  COMPLETED: 'completed',
  FAILED: 'failed',
} as const;

export const PAGE_SIZE = 10;

export const TOKEN_KEY = 'admin_token';
export const USER_KEY = 'admin_user';


